import { render, staticRenderFns } from "./myChoiceTransfer.vue?vue&type=template&id=542353d6&scoped=true"
import script from "./myChoiceTransfer.vue?vue&type=script&lang=js"
export * from "./myChoiceTransfer.vue?vue&type=script&lang=js"
import style0 from "./myChoiceTransfer.vue?vue&type=style&index=0&id=542353d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542353d6",
  null
  
)

export default component.exports